/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useContext } from 'react';
import { Popover, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Person } from 'assets/svg/person.svg';
import { AuthContext } from 'store/context';

function UserProfile() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const {
    AuthState: { authUser: user },
  } = useContext(AuthContext);

  const handleLogout = () => {
    setVisible(false);
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
    localStorage.removeItem('user');
    localStorage.removeItem('pos');
    window.location.href = '/login';
  };

  const redirectProfile = () => {
    setVisible(false);
    navigate('/profile');
  };

  const openDocs = () => {
    setVisible(false);
    window.open('/docs/', '_blank', 'noopener,noreferrer');
  };

  const userMenuOptions = (
    <ul>
      <li key="0" className="item-hover" onClick={redirectProfile}>
        <span className="align-middle text-sm text-grey-800 font-semibold">Tài khoản</span>
      </li>
      <li key="1" className="item-hover" onClick={openDocs}>
        <span className="align-middle text-sm text-grey-800 font-semibold">Hướng dẫn</span>
      </li>
      <li key="2" className="item-hover" onClick={handleLogout}>
        <span className="align-middle text-sm text-grey-800 font-semibold">Đăng xuất</span>
      </li>
    </ul>
  );

  return (
    <div role="button" className="omi-avatar" onClick={() => setVisible(!visible)}>
      <Popover
        placement="rightBottom"
        align={{ offset: [-15, 17] }}
        overlayInnerStyle={{ borderRadius: 4 }}
        overlayStyle={{ position: 'fixed' }}
        overlayClassName="omi-user-popover"
        content={userMenuOptions}
        visible={visible}
        onVisibleChange={visibleValue => setVisible(visibleValue)}
        trigger={['click']}
      >
        <Button type="primary" shape="circle" className="omi-avatar-button" icon={!user?.avatar ? <Person /> : null}>
          {user?.avatar ? (
            <img className="omi-avatar-image" src={user.avatar} alt={user?.full_name || 'avatar'} />
          ) : null}
        </Button>
        <span className="omi-avatar-name">{`${user ? user.full_name : ''}`}</span>
      </Popover>
    </div>
  );
}

export default UserProfile;
